import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import RatingEmoji from "../RatingEmoji";
import {
  Wrapper,
  Rating,
  Input,
  Label,
  Title,
  StepCount,
} from "../styles/rating-steps-styles";

interface ICommunicationProps {
  setRating: (event) => void;
  rating: number;
}

const Communication: FunctionComponent<ICommunicationProps> = ({
  setRating,
  rating,
}) => (
  <Wrapper noPointerEvents={rating}>
    <RatingEmoji rating={rating} />
    <Title>Communication</Title>
    <Rating className="rating">
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="step1Rating"
        id="rating-15"
        value={5}
      />
      <Label htmlFor="rating-15" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="step1Rating"
        id="rating-14"
        value={4}
      />
      <Label htmlFor="rating-14" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="step1Rating"
        id="rating-13"
        value={3}
      />
      <Label htmlFor="rating-13" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="step1Rating"
        id="rating-12"
        value={2}
      />
      <Label htmlFor="rating-12" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="step1Rating"
        id="rating-11"
        value={1}
      />
      <Label htmlFor="rating-11" />
    </Rating>
    <StepCount>step 1 of 5</StepCount>
  </Wrapper>
);

Communication.propTypes = {
  setRating: PropTypes.func.isRequired,
  rating: PropTypes.number,
};

Communication.defaultProps = {
  rating: null,
};

export default Communication;
